import React from "react";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";

import Textarea from "../../../../../components/common/textarea/Textarea";
import Button from "../../../../../components/common/button/Button";
import Error from "../../../../../components/common/error/Error";
import { required } from "../../../../../utils/forms/validators";

import close from "../../../../../assets/images/close-icon.svg";

import styles from "./RejectMemberModal.scss";

const RejectMemberModal = props => {
  const {
    invalid,
    submitting,
    pristine,
    memberName,
    rejectMember,
    onHide,
    handleSubmit
  } = props;

  return (
    <div className={styles.rejectMemberModal}>
      <div className={styles.modalContainer}>
        <img src={close} className={styles.closebutton} onClick={onHide} />
        <div className={styles.container}>
          <div className={styles.content}>
            <Form onSubmit={handleSubmit(rejectMember)}>
              <div className={styles.form}>
                <h2 className={styles.title}>Reject Member Application</h2>

                <div className={styles.dividerLine} />

                <div className={styles.subtitle}>
                  <p>Dear {memberName};</p>
                  <p>
                    Thank you so much for applying for membership with The
                    Second Shift. We reviewed your application and
                    unfortunately, we cannot accept you as a member at this
                    time.
                  </p>
                </div>

                <Field
                  name="comments"
                  placeholder="Insert Rejection Reason from Admin"
                  component={Textarea}
                  maxlength={255}
                  validate={[required]}
                />

                <div className={styles.subtitle}>
                  <p>We wish you all the best,</p>
                  <p>The Second Shift Team</p>
                </div>

                <Button
                  isDisabled={invalid || submitting || pristine}
                  isPrimary
                  type="submit"
                  size="large"
                  label="Reject + Send Message"
                />

                <Error />

                <Link to="#" onClick={onHide}>
                  Cancel and go back
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default reduxForm({
  form: "RejectMemberModal"
})(RejectMemberModal);



// WEBPACK FOOTER //
// ./src/routes/admin/memberModeration/components/rejectMemberModal/RejectMemberModal.js